module.exports = __webpack_public_path__ + "img/1.df3528e3.jpg";